import { apiClient } from "../../Service";
import { collectionToPostDistanceMission, postDistanceFormToObject, } from "./Transformer";
async function getDistanceMissions(alias) {
    const client = apiClient();
    return client
        .get("distance/missions", {
        // challenges with a distance modifier are not supported in mvm at this stage
        params: { exercise_type: alias, return_any_allowed: true, is_exclude_distance_modifier: true },
    })
        .then(collectionToPostDistanceMission);
}
const postDistance = (params) => {
    const client = apiClient();
    return client.post("distance/post", postDistanceFormToObject(params));
};
export const DistanceService = {
    getDistanceMissions,
    postDistance,
};
